/**
 *
 * @param value a string you want to remove the spaces from such as `1 2 3 4`
 * @returns the same string but with spaces such as `1234`
 */
export const removeAllSpaces = (value: string) => {
  const newValue = value.replace(/\s+/g, '');
  return newValue;
};
